<div *ngIf="messageEmitted" class="screen-overlay-message" (click)="closeOverlay();">
  <p [innerHTML]="message | safeHtml"></p>
</div>
